type BrowseUrlParams = {
  selectedDate: string;
  latitude?: number;
  longitude?: number;
  radius: number;
  currentBrowseUri?: string;
  sort?: string;
  pageSize?: number;
  treatmentCategoryIds?: number[];
};

export function generateBrowsePath({
  selectedDate,
  latitude,
  longitude,
  radius,
  currentBrowseUri = '/places',
  sort = 'distance',
  pageSize = 20,
  treatmentCategoryIds,
}: BrowseUrlParams): string {
  const path = '/api/v2/page/browse';

  const queryParams = new URLSearchParams({
    'date.from': selectedDate,
    'date.to': selectedDate,
    'location.radius': radius.toString(),
    currentBrowseUri,
    sort,
    pageSize: pageSize.toString(),
  });

  if (latitude) {
    queryParams.set('location.point.latitude', latitude.toString());
  }

  if (longitude) {
    queryParams.set('location.point.longitude', longitude.toString());
  }
  if (treatmentCategoryIds && treatmentCategoryIds.length > 0) {
    queryParams.set('treatmentCategoryIds', treatmentCategoryIds.join(','));
  }

  return `${path}?${queryParams.toString()}`;
}
